export const CANVAS_AI_APP_NAME = "Netpad.click";
export const CANVAS_AI_CONTENT_VERSION = 1;
export const CANVAS_AI_DRAFT_DOCUMENT_KEY = "draft";
export const CANVAS_AI_DEFAULT_MODEL_ID = "openrouter/free";
export const CANVAS_AI_MAX_ELEMENTS = 200;
export const CANVAS_AI_MAX_MESSAGES = 40;
export const CANVAS_AI_MAX_MODEL_OPTIONS = 50;
export const CANVAS_AI_MAX_OPERATIONS = 80;
export const CANVAS_AI_MAX_OUTPUT_TOKENS = 4000;
export const CANVAS_AI_MAX_STEPS = 5;
export const CANVAS_AI_MODEL_STORAGE_KEY = "netpad.canvas-ai.model";
export const CANVAS_AI_REMEMBERED_KEY_STORAGE_KEY =
  "netpad.canvas-ai.openrouter-key.remembered";
export const CANVAS_AI_SESSION_KEY_STORAGE_KEY =
  "netpad.canvas-ai.openrouter-key.session";
export const CANVAS_AI_TEMPERATURE = 0.2;

export const CANVAS_AI_LIMITS = Object.freeze({
  coordinate: 100000,
  fontSizeMax: 72,
  fontSizeMin: 12,
  sizeMax: 4000,
  sizeMin: 8,
  strokeWidthMax: 8,
  strokeWidthMin: 1,
  textLength: 500,
});

export const OPENROUTER_ENDPOINTS = Object.freeze({
  key: "https://openrouter.ai/api/v1/key",
  models: "https://openrouter.ai/api/v1/models/user",
});
